/* src/app/fxcmvideo/fxcmvideo.component.css */
::ng-deep .largeModal .modal-dialog {
  max-width: 80%;
  width: 80%;
  margin: auto;
  height: 80%;
}
.video-container {
  overflow: hidden;
  position: relative;
  max-width: 100%;
}
.video-container::after {
  padding-top: 56.25%;
  display: block;
  content: "";
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%;
  height: 100%;
  width: 100%;
  max-height: 100%;
}
::ng-deep .modal-body {
  height: 80%;
  max-height: 80%;
  margin: auto;
}
/*# sourceMappingURL=fxcmvideo.component.css.map */
